<template>
<div style="width:100%;">
    <Row>
        
        <Col span="12" offset="10"><div class="myTitle" :style="{margin: '20px 0'}">疑似事件结果页</div></Col>
        <Col span="2">
            <Breadcrumb :style="{margin: '20px 0'}">
              <Button type="success" size="small" @click="exportPage">导出</Button>
            </Breadcrumb>
        </Col>
    </Row>
   
     <hr style="margin:5px 30px;border: 5px solid #F9F9FB;"/><br/>
    <Row>
        <Col span="24">
            <Row>
                     <Col span="4" offset="1"> 任务名称： {{taskname}}</Col>
					 <Col span="6" > 任务编号： {{taskid}}</Col>
					 <Col span="4" > 任务类别： {{tasktype}}</Col>
					 <Col span="4" > 任务描述： {{taskdescribe}}</Col>
					 <Col span="4" > 任务目标： {{tasktarget}}</Col>
            </Row><br/>
			 <Row>
                     <Col span="4" offset="1"> 任务来源： {{tasksource}}</Col>
					 <Col span="6" > 关键词： {{keyword}}</Col>
					 <Col span="4" > 开始时间： {{starttime}}</Col>
					 <Col span="4" > 结束时间： {{endtime}}</Col>
					 <Col span="4" > 价格区间： {{minprice}}~{{maxprice}}</Col>
            </Row><br/>
			<Row>
				     <Col span="4" offset="1"> 任务执行人： {{taskExecutor}}</Col>
					 <Col span="12" > 检索范围： {{range}}</Col>
			</Row>
            
		    <hr style="margin:5px 30px;border: 1px solid #F9F9FB;"/><br/>
			  <Row >
                <Col span="10" offset="1">
                 <Form ref="queryFormRef" :model="queryForm" :label-width="60" inline>
	                   <FormItem label="" prop="addKeyword" >
                            <Input v-model="queryForm.addKeyword" placeholder="请输入关键词 "></Input>
                        </FormItem>
	                    <Button type="info"  @click="queryBtn">筛选</Button>
                 </Form>
                </Col>
                <Col span="8" offset="1">
	                <div>
	                    <Button type="error"  @click="updateRows(null)">转入确认案例</Button>
	                </div>
                </Col>
            </Row> 
            <Row>
                <Col span="24" >
                        <Table :loading="loading" @on-selection-change="selectRow"
                               border ref="table" stripe :columns="columns4" :data="listData">
                            <template slot-scope="{ row }" slot="name">
                                <strong>{{ row.name }}</strong>
                            </template>
                          
                        </Table>
                 </Col>
            </Row>
            <Row>
                <Col span="24">
                	<div>
                        <Footer>
                            <Page show-sizer show-total :total="rowCount" :current="current"
                                  :page-size="pageSize"  @on-change="changePage"
                                  @on-page-size-change="changeSize" />
                        </Footer>
                    </div>
            	</Col>
            </Row>
        </Col>
    </Row>
      
    </div>
    
</template>

<script>

   
    import { formatDate  } from "@/utils/time";
    import Bus from '@/utils/bus.js'
    
    export default {
        components: {
            
        },
        methods: {
           
            //询问是要转入确认
            updateRows(row) {
               
                    if(row == null){
                     if (this.selectRows.length == 0) {
                        this.$Message.error('请选择一条记录!');
                    } else {
                        let ids = []
                        for (let i = 0; i < this.selectRows.length; i++) {
                            ids.push(this.selectRows[i]._id)
                        }
                        this.updateIds = ids
                        this.$Modal.confirm({
                                title: '提示信息',
                                  content: '要转入确认案例吗?' ,
                                onOk: this.doUpdate
                        })
                    }
                }else{
                     this.updateIds = [row.id]
                     this.$Modal.confirm({
                     title: '提示信息',
                        content: '要转入确认案例吗?' ,
                        onOk: this.doUpdate
                     })
                }
            
               
            },
             //添加确认
            doUpdate() {
                
                this.loading = true
                let url = `/api/tasks/confirm`
                this.req({
                    url: url,
                    method: 'post',
                    data : {
                        type : 1,
                        dataIdList :this.updateIds ,// this.updateIds.join(","),
                        _id: this.taskid
                    },
                }).then(response => {
	                 this.$Message.success(
	                  {
	                    content:'转入成功!',
	                    top: 50,
	                    onClose: ()=>{
	                      	this.loading = false
                			this.loadPage();
	                    }
	                  }
	                )
                     this.selectRows=[]
                     this.loading = false
               }).catch(error => {
               		this.$Message.error('服务器错误:' + error)
               })
              
            },
           


             exportPage() {
                let url = `/api/export/suspected`
                this.req({
                    url: url,
                    method: 'post',
                    responseType: "arraybuffer",
                    data:{
                        type:"travel",
                         tag:"suspected",
                        _id:this.taskid,
                    }
                }).then(resp => {
                    this.fileDownload(resp.data, "file.xlsx");
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
               fileDownload(data, fileName) {
                    let blob = new Blob([data], {
                    type: "application/octet-stream"
                    });
                    let filename = fileName || "filename.xlsx";
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(blob, filename);
                    } else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", filename);
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                    }
              },
            loadPage() {
                let url = `/api/data/suspected`
                this.req({
                    url: url,
                    method: 'post',
                    data:{
                        type:"travel",
                        tag:"suspected",
                        _id:this.taskid,
                      p: this.current,
                      pageSize: this.pageSize,
                    }
                }).then(resp => {
                    this.buildPageData(resp.data.page)
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
            changePage(curPage) {
                this.loading = true
                this.current = curPage
                this.loadPage()
            },

            changeSize(pageSize) {
                this.pageSize = pageSize
                this.loading = true
                this.loadPage()
            },
            buildPageData(dataObj) {
                this.listData = dataObj.list;
                this.pageSize = dataObj.size;
                this.rowCount = dataObj.rowCount;
                this.currentPage = dataObj.p;
            },
            queryBtn(){
                this.current = 1
                this.loadPage()
            },
           
            selectRow(selection) {
                this.selectRows = selection;
            },
            resetQueryForm() {
             	this.$refs["queryFormRef"].fields.forEach(function (e) {
		           e.resetField()
		        })
            },
           
         
        },
        mounted: function () {
			let row =this.$route.query.row
			this.taskname=row.taskName
			this.taskid =row._id
			if(row.taskType==1){
				this.tasktype ='专项任务'
			}else if(row.taskType==0){
				this.tasktype ='循环任务'
			}
			this.taskdescribe = row.taskInfo
			this.tasktarget = row.taskTarget
			this.tasksource = row.taskSource
            this.taskExecutor = row.taskExecutor
			this.endtime = row.taskEndTime
			this.starttime = row.taskStartTime
            this.createTime = row.createTime
			this.keyword = row.keyword
			this.minprice = row.minPrice
			this.maxprice =row.maxPrice
			this.range = '网站('+row.huntingZone.website+')\xa0\xa0\xa0\xa0\xa0\xa0 APP('+row.huntingZone.app +') '
            this.website = row.huntingZone.website
            this.app = row.huntingZone.app
           // this.wechat = row.huntingZone.wechat
            this.loadPage()
           // this.exportPage()
        },
        data() {
            return {
                listData: [],
                listData1: [],
                pageSize: 10,
                current: 1,
                rowCount: 0,
                loading: true,
                createTime:'',
                taskname:'',
                taskid:'',
                tasktype:'',
                tasktype:'',
                taskdescribe:'',
                tasktarget:'',
                tasksource:'',
                taskExecutor:'',
                starttime:'',
                endtime:'',
                keyword:'',
                wechat:[],
                website:[],
                app:[],
                minprice:'',
                maxprice:'',
                searchallnum:0,
                range:'',
                days:1,
                searchcount:0,
                curnum:0,
                selectRows: [],
                deleteIds: [],
                columns4: [{
                        type: 'selection',
	                    width: 55,
	                    align: 'center',
                    },{
                        type: 'index',
                        title: '序号',
	                    width: 70,
	                    align: 'center',
                    },
                    {
                        title: '标题',
                        key: 'title' ,
                        align: 'center',
                    },{
                        title: '链接地址',
                        key: 'url' ,
                        align: 'center',
                    },{
                        title: '来源',
                        key: 'source' ,
                        width: 80,
                        align: 'center',
                    },{
                        title: '类型',
                        key: 'type' ,
                        width: 90,
                        align: 'center',
                    },{
                        title: '价格',
                        key: 'price' ,
                        width: 90,
                        align: 'center',
                    },{
                        title: '供应商',
                        key: 'supplierInfo' ,
                        align: 'center',
                    },{
                        title: '是否有资质',
                        key: 'localSupplier' ,
                        width: 100,
                        align: 'center',
                         render:  (h, params) =>{
                                if(params.row.localSupplier=='1'){
                                    return h('div', "是");
                                }else if(params.row.localSupplier=='0'){
                                    return h('div', "否");
                                }
                            }
                    },{
                        title: '法人',
                        key: 'companyCorp' ,
                        align: 'center',
                    },{
                        title: '地址',
                        key: 'companyAddress' ,
                        align: 'center',
                    },{
                        title: '电话',
                        key: 'tel1' ,
                        align: 'center',
                        render:  (h, params) =>{
                                 if(params.row.tel1!=''&&params.row.tel2!=''){
                                    return h('div', params.row.tel1 +'\xa0;\xa0' +params.row.tel2 );
                                 }else{
                                    return h('div', params.row.tel1 +params.row.tel2 );
                                 }
                                    
                             }
                    }
                ],

               //查询表单的初始值
                queryForm: {
                    addKeyword: '',
                }
            }
        },

    }
</script>

<style scoped>
.myTitle{
      font-size: 20px;
      font-weight: 700;
     }
</style>


// WEBPACK FOOTER //
// src/pages/platform/suspected/SuspectedSearh.vue